import { ChangeDetectorRef, Component, HostListener, Input, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { get } from 'lodash';
import { NftService } from '../../../services/nft.service';

import { WalletConnectService, ethereumClient, wagmiConfig, web3Modal } from 'src/app/services/wallet-connect.service';
import { GetAccountResult, watchNetwork, watchAccount } from '@wagmi/core';
import { ApiService } from 'src/app/services/api.service';
import CryptoJS from 'crypto-js';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nft-verify',
  templateUrl: './nft-verify.component.html',
  styleUrls: ['./nft-verify.component.scss'],
})
export class NftVerifyComponent implements OnInit {
  @Input() data;
  @Input() controls;
  @Input() config;
  watchAccountTriggered: boolean = false;
  isApiCallInProgress: boolean = false; // New flag to prevent multiple API calls
  address: string;


  @HostListener('document:visibilitychange', ['$event'])
  onVisibilityChange(event: Event): void {
    web3Modal.closeModal();
    if (document.visibilityState === 'visible' && !this.watchAccountTriggered) {
      console.log('Tab is active!');
      this.watchAccountTriggered = true;
      // this.checkWalletStatus();
    }
  }


  public walletConnectStatus: boolean;
  public isWalletConnected: boolean = false;
  public asset = {};
  public isLoading: boolean;
  public tokenId: string = null;
  public contractAddress: string = null;
  public wc: GetAccountResult;
  public blockChainName: string = null;
  tokenStandard: any;


  checkWalletStatus(): void {
    console.log('Checking wallet status...');
    let acc = this.getAccount();
    this.isWalletConnected = acc.isConnected;
    if (acc.isConnected) {
      this.getAsset(acc.address);
    } else {
      this.asset = null;
    }
    this.watchAccountTriggered = false;
  }

  // get isOwner() {
  //   return this._isOwner;
  // }

  // set isOwner(value: boolean) {
  //   this._isOwner = value;
  // }

  constructor(
    private nftService: NftService,
    public cdr: ChangeDetectorRef,
    private appService: AppService,
    private apiService: ApiService
  ) {
    // Subscribe to NFT verification result changes
    this.nftService.getWalletConnectNftStatusObservable().subscribe(result => {
      this.walletConnectStatus = result;
      this.isLoading = false;
    });
  }

  ngOnInit() {

    this.wc = this.getAccount();
    this.isWalletConnected = this.wc?.isConnected;
    if (this.isWalletConnected) {
      if (this.wc?.address) {
        this.getAsset(this.wc?.address);
      }
    }

    web3Modal.subscribeModal((data) => {
      this.wc = this.getAccount();
      this.isWalletConnected = this.wc?.isConnected;
      if (this.wc?.address) {
        this.getAsset(this.wc?.address);
      }
      this.isLoading = false;
    });

    const acc = watchAccount((acco) => {
      web3Modal.closeModal();
      this.isWalletConnected = acco.isConnected;
      if (acco.isConnected) {
        this.getAsset(acco.address);
      } else {
        this.asset = null;
      }
      this.isLoading = false;

    });
  }

  getAccount() {
    return ethereumClient.getAccount();
  }

  getAsset(walletAddress: string) {
    let sessionStorageAddress = sessionStorage.getItem('wallet-address');
    if (sessionStorageAddress != walletAddress) {
      sessionStorage.setItem('wallet-address', walletAddress)
      this.nftService.setWalletConnectNftStatus(null);
      this.isLoading = true;
      const secretKey = 'QlikTag@Inc!@#$%';
      let encryptedData = CryptoJS.AES.encrypt(walletAddress, secretKey).toString();
      const walletEncrypted = encodeURIComponent(encryptedData);
      const lastApiCall = sessionStorage.getItem('lastApiCall');
      let thirdWebPayload = {
        w: walletEncrypted
      };

      const handleResponse = (data) => {
        this.nftOwnerVerification(data);
        this.isLoading = false;
      };

      const handleError = (error) => {
        console.error('Error:', error);
        this.isLoading = false;
      };

      if (lastApiCall === 'getDIByDigitalLink') {
        this.apiService.getDIByDigitalLink(null, null, thirdWebPayload).subscribe({
          next: handleResponse,
          error: handleError,
        });
      } else if (lastApiCall === 'getDIByShortCode') {
        this.apiService.getDIByShortCode(null, null, thirdWebPayload).subscribe({
          next: handleResponse,
          error: handleError,
        });
      }
    }

  }

  foundNftIncludePage(digitalInteractionPage: any) {
    for (let page in digitalInteractionPage) {
      let controlFound = this.foundNftIncludeControl(digitalInteractionPage[page].controls);
      if (controlFound !== null) {
        return controlFound; // Return the control if found
      }
    }
    return null;
  }

  foundNftIncludeControl(controls: any) {
    for (let i = 0; i < controls.length; i++) {
      if (controls[i].ctrlName == 'nft-verify') {
        return controls[i];
      } else if (controls[i].controls && controls[i].controls.length) {
        let foundNft = this.foundNftIncludeControl(controls[i].controls);
        if (foundNft) return foundNft;
      }
    }
    return null;
  }

  nftOwnerVerification(data: any) {
    let digitalInteractionPage = data.vdi.diLayout.pages;
    const foundNFtIncludedPage = this.foundNftIncludePage(digitalInteractionPage);
    if (data.vdi.NftVerificationResult == false) {
      this.appService.makeToast('Blockchain/TokenStandard for this token is unknown');
    }
    if (foundNFtIncludedPage && data.vdi.NftVerificationResult) {
      this.controls = foundNFtIncludedPage.controls;
      this.config = foundNFtIncludedPage.config;
      this.nftService.setWalletConnectNftStatus(data.vdi.NftVerificationResult);
      this.walletConnectStatus = data.vdi.NftVerificationResult;

      // this.isOwner = true;
      this.isLoading = false;
    } else {
      this.nftService.setWalletConnectNftStatus(data.vdi.NftVerificationResult);
      this.isLoading = false;
    }
  }

  checkOwnership(walletAddress: string, owner): boolean {
    let result = false;
    if (owner) {
      return owner?.toLowerCase() === walletAddress.toLowerCase();
    }
    return result;
  }

}
